<script>
import { Line } from "vue-chartjs";

// apexcharts
export default {
  name: "ParameterDynamicChart",
  extends: Line,

  props: {
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.renderChart(this.data, this.options);
  },
};
</script>
